// utility functions for URL slug generation
import { getCountryFromPhone } from '../services/mappingService';
import { SITE_URL } from '../config/domain';

export const createEscortSlug = (name: string): string => {
  return name
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .trim()
    .replace(/^-+|-+$/g, '');
};

export const createEscortUrl = (escort: { phone?: string; name: string; location: string }, countryCodeOverride?: string, absolute?: boolean): string => {
  const slug = createEscortSlug(escort.name);
  const phone = (escort.phone || '').trim();

  // Determina il country code tramite mapping (caricato all'avvio), con fallback al prefisso telefonico
  const countryCode = countryCodeOverride || getCountryFromPhone(phone);

  const path = `/${countryCode}/escort/${phone}/${slug}`;
  return absolute ? `${SITE_URL}${path}` : path;
};

export const parseEscortSlug = (slug: string): { name: string; city: string } => {
  // For parsing, we need to be smarter about where the name ends and city begins
  // We'll use a simple heuristic: if the slug contains common Italian city patterns,
  // we can identify them better

  const parts = slug.split('-');
  if (parts.length < 2) {
    return { name: '', city: '' };
  }

  // Common patterns for Italian locations
  const locationPatterns = [
    'marche', 'roma', 'milano', 'napoli', 'torino', 'firenze', 'bologna',
    'venezia', 'bari', 'catania', 'verona', 'messina', 'padova', 'trieste'
  ];

  // Look for location patterns in the slug
  let nameEndIndex = parts.length - 1; // Default: everything except last part is name

  // Check if we have a compound location (like civitanova-marche)
  for (let i = parts.length - 1; i >= 1; i--) {
    const possibleLocation = parts.slice(i - 1).join(' ');
    if (possibleLocation.includes('civitanova marche') ||
        possibleLocation.includes('roma') ||
        locationPatterns.some(pattern => possibleLocation.includes(pattern))) {
      nameEndIndex = i - 1;
      break;
    }
  }

  // If we couldn't find a pattern, use simple split (name = all but last, city = last)
  const name = parts.slice(0, nameEndIndex).join(' ');
  const city = parts.slice(nameEndIndex).join(' ');

  return { name, city };
};

export const findEscortBySlug = (escorts: Array<any>, slug: string): any => {
  // const { name, city } = parseEscortSlug(slug);
  return escorts.find(escort => {
    const escortSlug = createEscortSlug(escort.name);
    return escortSlug === slug;
  });
};

export const findEscortByPhone = (escorts: Array<any>, phone: string): any => {
  return escorts.find(escort => escort.phone === phone || escort.pphone === phone);
};

export const createReviewsUrl = (escort: { phone?: string; name: string; location: string }, countryCodeOverride?: string, absolute?: boolean): string => {
  const slug = createEscortSlug(escort.name);
  const phone = (escort.phone || '').trim();
  const countryCode = countryCodeOverride || getCountryFromPhone(phone);
  const path = `/${countryCode}/recensioni/${phone}/${slug}`;
  return absolute ? `${SITE_URL}${path}` : path;
};

